var map = {
	"./de.json": 1730,
	"./dk.json": 6036,
	"./en.json": 1754,
	"./fr-BE.json": 4045,
	"./fr.json": 1665,
	"./nl.json": 3355,
	"./no.json": 4138,
	"./sv.json": 3280
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4822;